// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLabelledItem-Label_cls1__DzhfI","cls2":"VeloLabelledItem-Label_cls2__PIeV8 VeloLabelledItem-Label_cls1__DzhfI","disabled":"VeloLabelledItem-Label_disabled__K8oWW"};